<p class="geogebra-explanation" translate="f.geogebra.info"></p>
<ng-content></ng-content>
<div id="ggb-element-{{ value }}"></div>
